






import {Component, Vue} from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue"
import YcAside from "@/components/common/yc-aside.vue"
import {getToken, verifySuccess} from "@/services/api";
import Content from '../components/home/content.vue'
import { getQueryVariable } from "@/services/api";
@Component({
  components: {
    'yc-aside': YcAside,
    'zf-content': Content,
    'yc-header': YcHeader
  },
})
export default class Home extends Vue {

  async created(): Promise<void> {
    if (this.$route.query.verify === 'success') {
      await verifySuccess({})
    }
    if (getQueryVariable('state') === '-1') {
      process.env.NODE_ENV === 'production' && getToken() !== 'default' && window.location.replace(process.env.VUE_APP_DOMAIN + `/cartsee-new/dashboard${this.$route.fullPath.slice(5)}`);
    } else { 
      process.env.NODE_ENV === 'production' && getToken() !== 'default' && window.location.replace(process.env.VUE_APP_DOMAIN + '/cartsee-new/dashboard');
    }
    
    process.env.NODE_ENV === 'production' && getToken() === 'default' && window.location.replace(process.env.VUE_APP_DOMAIN  + '/cartsee-new/login');
  }

}
